import React, { useEffect, useState } from 'react';
import { BackButton } from 'components/buttons';
import Header from 'components/header/Header';
import useDatasetList from 'views/Datasets/hooks/useDatasetList';
import { SearchFilter } from 'types/Filters';
import { getPageNumber, getPageSize } from 'components/pager/getPageDetails';
import useDatasetListLabels from 'views/Datasets/hooks/useDatasetLabels';
import AutocompleteSearchBar from 'components/search/AutocompleteSearchBar';
import { useLocation } from 'react-router-dom';
import WelcomeView from './WelcomeView';
import FilterView from './Components/FiltersView';
import { trackEvent } from 'analytics/AWSRumService';
const sharesFilter = {
    term: '',
    page: 1,
    pageSize: 100,
};
const HomePage = () => {
    const location = useLocation();
    const initialTerm = new URLSearchParams(location.search).get('query') || '';
    const [filter, setFilter] = useState<SearchFilter>({
        page: getPageNumber(location.search),
        pageSize: getPageSize(4, 3),
        term: initialTerm,
        roles: [],
        sort: [],
        onlyProduction: true,
    });
    // If there is a query, we should open the filters
    const { items, error, loading } = useDatasetList(filter, sharesFilter);

    const { datasetLabels, loadingLabels } = useDatasetListLabels({
        count: items.count,
    });

    const [filtersOpen, setFiltersOpen] = useState(false);

    useEffect(() => {
        trackEvent('screen_size', {
            screenWidth: window.screen.width,
            screenHeight: window.screen.height,
            windowInnerWidth: window.innerWidth,
            windowInnerHeight: window.innerHeight,
        });
    }, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        setFiltersOpen(searchParams.has('query'));
    }, [location.search]); // Update filtersOpen whenever location.search changes

    return (
        <div>
            {filtersOpen && (
                <BackButton onClickExtra={() => setFiltersOpen(false)} />
            )}
            <Header
                title={`${filtersOpen ? 'Search results' : 'Welcome to DataHub'}`}
            />
            <AutocompleteSearchBar
                onTermChange={(e: string) => {
                    setFilter({ ...filter, term: e });
                }}
                items={datasetLabels}
                loading={loadingLabels}
                placeholder="Search for datasets available on DataHub..."
                setFiltersOpen={setFiltersOpen}
            />
            {!filtersOpen ? (
                <WelcomeView
                    items={items}
                    error={error}
                    loading={loading}
                    filter={filter}
                    setFilter={setFilter}
                    setShowFilters={setFiltersOpen}
                />
            ) : (
                <FilterView
                    items={items}
                    error={error}
                    loading={loading}
                    filter={filter}
                    setFilter={setFilter}
                    setShowFilters={setFiltersOpen}
                />
            )}
        </div>
    );
};

export default HomePage;
